import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SEO from "@/components/SEO";
import { ShieldWm } from "@/components/Watermark";
import { FadeUp, MaskedLine, Eyebrow, DrawLine, ParallaxImg } from "@/components/Reveal";
import QuoteCTA from "@/components/QuoteCTA";

const KHALID_PORTRAIT =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_elite-transfer-italy/artifacts/cboc7dja_IMG-20260521-WA0041.jpg";
const CHAPTERS = [
  {
    n: "01",
    t: "Il cliente al centro",
    d: "Zaichauffer nasce con l'obiettivo di offrire un servizio di chauffeur privato basato su un principio semplice: mettere il cliente al centro di ogni viaggio.",
  },
  {
    n: "02",
    t: "Un rapporto diretto",
    d: "Khalid El Aissaoui segue personalmente il servizio, mantenendo un rapporto diretto con il cliente e curando ogni dettaglio del trasferimento.",
  },
  {
    n: "03",
    t: "Ogni viaggio, un'esperienza",
    d: "Che si tratti di un viaggio di lavoro, di un trasferimento aeroportuale, di un evento o di uno spostamento privato, l'obiettivo è offrire un'esperienza caratterizzata da puntualità, comfort e discrezione.",
  },
];

export default function ChiSiamo() {
  return (
    <>
      <SEO
        title="Chi siamo | Zaichauffer – Chauffeur Privato in Italia"
        description="Zaichauffer è il servizio di autista privato gestito direttamente da Khalid El Aissaoui: un rapporto diretto, senza intermediari, per trasferimenti in in tutta Italia."
      />

      <section className="relative isolate mx-auto max-w-7xl overflow-hidden px-6 pb-20 pt-40 md:pb-28 md:pt-52" data-testid="chi-siamo-hero">
      <ShieldWm className="-z-10 -right-24 top-10 w-[400px] opacity-[0.04]" />
        <FadeUp>
          <Eyebrow>Chi siamo</Eyebrow>
        </FadeUp>
        <h1 className="mt-10 font-serif text-4xl leading-[1.08] tracking-tight text-bone sm:text-5xl lg:text-6xl">
          <MaskedLine>PERSONALITÀ, PROFESSIONALITÀ,</MaskedLine>
          <MaskedLine delay={0.15}>DISCREZIONE.</MaskedLine>
        </h1>
        <DrawLine className="mt-10" />
      </section>

      <section className="mx-auto max-w-7xl px-6 pb-24 md:pb-36" data-testid="founder-section">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <FadeUp className="lg:sticky lg:top-32">
              <div className="frame-gold">
                <ParallaxImg
                  src={KHALID_PORTRAIT}
                  alt="Khalid El Aissaoui, titolare e chauffeur di Zaichauffer, accanto al veicolo"
                  className="relative z-10 aspect-[4/5] w-full"
                />
              </div>
              <p className="label-cap mt-6 !text-[9px]">
                Khalid El Aissaoui — Titolare e Chauffeur
              </p>
            </FadeUp>
          </div>

          <div className="lg:col-span-7">
            <div className="space-y-0">
              <div className="pb-12">
                <Eyebrow>Il tuo autista</Eyebrow>
                <h2 className="mt-8 font-serif text-2xl text-bone md:text-3xl">
                  Khalid, il tuo chauffeur.
                </h2>
                <p className="mt-5 max-w-xl text-[15px] font-light leading-relaxed text-mute">
                  Il titolare in persona: Khalid El Aissaoui accompagna
                  personalmente ogni cliente, curando ogni dettaglio del
                  trasferimento con la massima puntualità e discrezione, in
                  Italia e in Europa.
                </p>
                <a
                  href="https://wa.me/393208189469"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="lux-link group mt-8 inline-flex"
                  data-testid="founder-whatsapp-link"
                >
                  Scrivi a Khalid su WhatsApp
                  <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
              {CHAPTERS.map((c, i) => (
                <FadeUp key={c.n} delay={0.05 * i}>
                  <div className="border-t border-white/10 py-12">
                    <div className="flex flex-col gap-6 md:flex-row md:items-baseline md:gap-12">
                      <span className="font-serif text-3xl italic text-gold/80">
                        {c.n}
                      </span>
                      <div className="max-w-xl">
                        <h2 className="font-serif text-2xl text-bone md:text-3xl">
                          {c.t}
                        </h2>
                        <p className="mt-5 text-[15px] font-light leading-relaxed text-mute">
                          {c.d}
                        </p>
                      </div>
                    </div>
                  </div>
                </FadeUp>
              ))}
              <div className="border-t border-white/10" />
            </div>

            <FadeUp delay={0.1}>
              <div className="mt-8 flex flex-col gap-4 sm:flex-row">
                <Link to="/richiedi-preventivo" className="btn-solid group">
                  Richiedi un preventivo
                  <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link to="/contatti" className="btn-outline">
                  Parla direttamente con Khalid
                </Link>
              </div>
            </FadeUp>
          </div>
        </div>
      </section>

      <QuoteCTA />
    </>
  );
}
